module.exports = __webpack_public_path__ + "images/init/reports-empty@2x-c29fc8a946da4ba30e8eeeca21f3c47c.png";